import { gridSize } from '@atlaskit/theme';
import styled from '@emotion/styled';

const Header = styled.h4`
    font-size: 1.5em;
    font-style: inherit;
    line-height: 1.2;
    font-weight: 500;
    margin-top: ${gridSize() * 2}px;
    margin-bottom: ${gridSize() * 2}px;
`;

export default Header;
